import { render, staticRenderFns } from "./TaskElement.vue?vue&type=template&id=d5614dcc&scoped=true&"
import script from "./TaskElement.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskElement.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TaskElement.vue?vue&type=style&index=0&id=d5614dcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5614dcc",
  null
  
)

export default component.exports